export enum StatusTask {
  RUNNING = 'Running',
  WAITING = 'Waiting',
  FAILED = 'Failed',
  SUCCESS = 'Success'
}

export enum VisibilitySpectrum {
  DISPLAY = 'Published',
  READY = 'Ready to publish',
  HIDDEN = 'Hidden'
}

export enum Accessibility {
  PUBLIC = 'Public',
  PRIVATE = 'Private'
}

export interface PaginationResponse {
  count: number
  num_pages: number
  start_index: number
  end_index: number
  results: Array<any>
}
